import { render } from "./AboutComp.vue?vue&type=template&id=4b6bce66&scoped=true"
import script from "./AboutComp.vue?vue&type=script&lang=js"
export * from "./AboutComp.vue?vue&type=script&lang=js"

import "./AboutComp.vue?vue&type=style&index=0&id=4b6bce66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6bce66"]])

export default __exports__